var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(0.666626)",
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0502 12.9865C19.0821 12.9067 17.1611 13.4664 15.645 14.5419C14.1311 15.616 13.1348 17.1214 12.803 18.7608C12.4718 20.3971 12.8167 22.0929 13.7951 23.54L14.0713 23.9485L13.168 26.6582L16.4944 25.9505L16.8034 26.1005C18.5175 26.9327 20.5243 27.1868 22.4441 26.8065C24.3637 26.4262 26.0375 25.4438 27.1689 24.0712C28.2973 22.7022 28.8135 21.0367 28.6515 19.3825C28.4893 17.7268 27.6541 16.154 26.263 14.9675C24.8693 13.7787 23.0183 13.0663 21.0502 12.9865ZM14.4878 12.9108C16.3811 11.5675 18.7417 10.8912 21.1313 10.9881C23.5208 11.085 25.8071 11.9499 27.5609 13.4458C29.3173 14.9439 30.4258 16.9804 30.642 19.1876C30.8583 21.3963 30.1619 23.5844 28.7122 25.3433C27.2654 27.0984 25.1709 28.3052 22.8328 28.7684C20.6113 29.2085 18.288 28.9546 16.2482 28.0476L10.1653 29.3419L11.8678 24.2344C10.8048 22.45 10.4344 20.3813 10.8427 18.364C11.2834 16.1872 12.5924 14.2555 14.4878 12.9108Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6666 19V21.01H19.6666V19H21.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6666 19V21.01H15.6666V19H17.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6666 19V21.01H23.6666V19H25.6666Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatUs);
export default __webpack_public_path__ + "static/media/chat-us.9c3028eb2b57a3b30b3e992555bad1b8.svg";
export { ForwardRef as ReactComponent };